import * as React from 'react';
import { DataGrid } from '@catapultsports/referee-react';
import { useTranslations } from 'i18n';
import { DeepActivityPeriod } from 'oas';
import { useMemo } from 'react';
import { ColDef } from 'ag-grid-community';
import { SyncToFocusCellRenderer } from './sync-to-focus-cell-renderer';
import { DATE_FNS_ACTIVITY_EDITOR_TIME_FORMAT, getFormattedDuration, useDateFormatter } from 'shared';
import { SyncToFocusSelectProps } from './sync-to-focus-select';
import { calcTableHeight } from '../../../reporting/helpers';

export interface FocusTableProps {
    periods: DeepActivityPeriod[];
    syncToFocusOptions: string[];
}

export const FocusTable: React.FC<FocusTableProps> = (props) => {
    const { periods, syncToFocusOptions } = props;

    //Hooks
    const { __ } = useTranslations();
    const formatDate = useDateFormatter();

    const FOCUS_COLUMN_DEF: ColDef[] = [
        {
            headerName: __('focus.openfield_periods'),
            field: 'openfield_periods',
            sortable: true,
        },
        {
            headerName: __('misc.start_time'),
            field: 'start_time',
            sortable: true,
        },
        {
            headerName: __('misc.duration'),
            field: 'duration',
            sortable: true,
        },
        {
            headerName: __('focus.sync_to_focus'),
            field: 'sync_to_focus',
            cellRenderer: SyncToFocusCellRenderer,
        },
    ];

    const rowData = useMemo(() => {
        return periods.map((period) => {
            return {
                openfield_periods: period.name,
                start_time: formatDate(new Date(period?.start_time ?? 0 * 1000), DATE_FNS_ACTIVITY_EDITOR_TIME_FORMAT),
                duration: getFormattedDuration(period.start_time ?? 0, period.end_time ?? 0),
                sync_to_focus: {
                    testId: period.id,
                    options: syncToFocusOptions,
                    onChange: (value: string) => {
                        alert(`Period ${period.name} maps to ${value}`);
                    },
                } as SyncToFocusSelectProps,
            };
        });
    }, [formatDate, periods, syncToFocusOptions]);

    return (
        <div style={{ height: `${calcTableHeight(rowData)}` }}>
            <DataGrid
                testId="focus-table"
                columnDefs={FOCUS_COLUMN_DEF}
                rowData={rowData}
                gridOptions={{
                    overlayNoRowsTemplate: `${__('misc.no_data_available')}`,
                }}
                dense
            />
        </div>
    );
};
